import { defineAsyncComponent } from 'vue';

export const emailSettingsMicroFrontends = {
	EmailServiceSettings: defineAsyncComponent(
		() => import('./components/EmailServiceSettings.vue')
	),
};
